import { DashboardLayout } from "../../../components/layouts/DashboardLayout";

export const KnowledgeCloudPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <div className="px-6 pt-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-white text-base">Nuvem de Conhecimento</h1>
        </div>

        <div className="text-white/80">
          {/* Content will be added in future implementations */}
          Conteúdo em desenvolvimento
        </div>
      </div>
    </div>
  );
};
